import { render, staticRenderFns } from "./WrongHome.vue?vue&type=template&id=32e2211a&scoped=true"
import script from "./WrongHome.vue?vue&type=script&lang=ts"
export * from "./WrongHome.vue?vue&type=script&lang=ts"
import style0 from "./WrongHome.vue?vue&type=style&index=0&id=32e2211a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e2211a",
  null
  
)

export default component.exports